import React from 'react'
import { CloseButton as BsCloseButton } from 'react-bootstrap'
import { TooltipPopOver } from '../TooltipPopOver'
import styles from './styles.module.scss'

export const CloseButton = ({ onClick }: { onClick: (e: any) => void }) => {
  return (
    <TooltipPopOver tooltipBody="Close">
      <BsCloseButton onClick={onClick} className={styles.btnClose} />
    </TooltipPopOver>
  )
}
